import React from 'react'
import Tooltip from '@mui/material/Tooltip'

import { InfoBadge, Kpi, KpiLabel, Kpis, KpiValue } from './styled'

export default function AnalyticsKpis({ items = [], t }) {
  return (
    <Kpis aria-label={t('analytics_kpi_summary')}>
      {items.map((item, index) => (
        <Kpi key={item.key} primary={index < 4}>
          <KpiLabel>
            {t(item.labelKey || `analytics_kpi_${item.key}`)}
            {!item.helpKey ? null : (
              <Tooltip
                arrow
                enterTouchDelay={0}
                leaveTouchDelay={3000}
                placement="top"
                title={t(item.helpKey)}
              >
                <InfoBadge
                  aria-label={t(item.helpKey)}
                  onClick={event => event.currentTarget.focus()}
                  type="button"
                >i</InfoBadge>
              </Tooltip>
            )}
          </KpiLabel>
          <KpiValue>{item.formattedValue}</KpiValue>
        </Kpi>
      ))}
    </Kpis>
  )
}
